// src/components/SensorDashboard.js
import React, { useState, useEffect } from 'react';
import { Box, Text, Stat, StatLabel, StatNumber, StatHelpText, StatGroup, useBreakpointValue } from '@chakra-ui/react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend } from 'chart.js';
import { getSensorData } from '../utils/firebase.utils';

// Register Chart.js components
ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend);

const SensorDashboard = ({ sensor }) => {
  const [sensorData, setSensorData] = useState([]);
  const isMobile = useBreakpointValue({ base: true, md: false });

  useEffect(() => {
    const fetchSensorData = async () => {
      const data = await getSensorData(sensor.id);
      setSensorData(data);
    };
    fetchSensorData();
  }, [sensor]);

  const chartData = {
    labels: sensorData.map(data => data.timestamp.toLocaleDateString()),
    datasets: [
      {
        label: 'Temperature (°C)',
        data: sensorData.map(data => data.temperature),
        borderColor: 'rgba(75,192,192,1)',
        fill: false,
      },
      {
        label: 'Humidity (%)',
        data: sensorData.map(data => data.humidity),
        borderColor: 'rgba(153,102,255,1)',
        fill: false,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false, // Allows the chart to fill the container
    scales: {
      x: {
        type: 'category',
        title: {
          display: true,
          text: 'Date',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Value',
        },
      },
    },
  };

  return (
    <Box p={4}>
      <StatGroup>
        <Stat>
          <StatLabel>Status</StatLabel>
          <StatNumber>{sensor.status}</StatNumber>
          <StatHelpText>Last Sync: {sensor.lastSync.toLocaleString()}</StatHelpText>
        </Stat>
        <Stat>
          <StatLabel>Gateway</StatLabel>
          <StatNumber>{sensor.gatewayId}</StatNumber>
        </Stat>
        {/* Add more statistics as needed */}
      </StatGroup>
      <Box mt={4}>
        <Text fontSize={isMobile ? 'lg' : 'xl'}>{sensor.name} Data</Text>
        <Box height="400px" width="100%"> {/* Set a fixed height for the chart container */}
          <Line data={chartData} options={chartOptions} />
        </Box>
      </Box>
    </Box>
  );
};

export default SensorDashboard;